"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.string.small");
function _templateObject() {
    var data = _taggedTemplateLiteralLoose(["\n  .wrapper {\n    display: flex;\n    box-shadow: var(--shadow-light);\n    text-decoration: none;\n    color: inherit;\n\n    @media (max-width: ", ") {\n      flex-direction: column;\n      max-width: 40rem;\n    }\n\n    @media (max-width: ", ") {\n      margin: 0 auto;\n    }\n  }\n\n  .img {\n    min-height: 22rem;\n    min-width: 22rem;\n    background: url(", ");\n    background-size: cover;\n    background-position: center;\n  }\n\n  .g-image {\n    min-height: 22rem;\n    min-width: 22rem;\n\n    .gatsby-image-wrapper {\n      height: 100%;\n      width: 100%;\n    }\n  }\n\n  .text {\n    flex: 1;\n    padding: var(--gutter-small-1) var(--gutter-small);\n    border: var(--border-light-1);\n    border-left: none;\n\n    & > * {\n      &:not(:last-child) {\n        margin-bottom: var(--gutter-small-3);\n      }\n    }\n  }\n\n  &:not(:last-of-type) {\n    margin-bottom: var(--gutter-large-1);\n  }\n"]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} strings.raw = raw; return strings; }
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const post_banner_jpg_1 = __importDefault(require("../../resources/post-banner.jpg"));
const variables_1 = require("../../styles/variables");
const gatsby_1 = require("gatsby");
const gatsby_image_1 = __importDefault(require("gatsby-image"));
const CompanyAndTags_1 = __importDefault(require("../CompanyAndTags"));
var StyledPostBanner = styled_1.default.article(_templateObject(), variables_1.breakpoints.medium, variables_1.breakpoints.small, post_banner_jpg_1.default);
var PostBanner = function PostBanner(_ref) {
    var date = _ref.date, title = _ref.title, slug = _ref.slug, excerpt = _ref.excerpt, organisation = _ref.organisation, tags = _ref.tags, teaser = _ref.teaser;
    return /*#__PURE__*/ react_1.default.createElement(StyledPostBanner, null, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "wrapper"
    }, teaser ? /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/writing/" + slug,
        className: "g-image"
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_image_1.default, {
        fluid: teaser
    })) : /*#__PURE__*/ react_1.default.createElement("div", {
        className: "img"
    }), /*#__PURE__*/ react_1.default.createElement("div", {
        className: "text"
    }, /*#__PURE__*/ react_1.default.createElement("p", null, new Date(date).toLocaleDateString("en-GB", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
    })), /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/writing/" + slug
    }, /*#__PURE__*/ react_1.default.createElement("h3", null, title)), /*#__PURE__*/ react_1.default.createElement(CompanyAndTags_1.default, {
        organisation: organisation,
        tags: tags
    }), /*#__PURE__*/ react_1.default.createElement("p", null, excerpt))));
};
exports.default = PostBanner;
